import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, } from "@azure/msal-react";
import Header from "./components/Header";
import AddStockBucket from "./components/AddStockBucket";
import StockBucketList from "./components/StockBucketList";
import { getWarehouses } from "./services/api";
import "./App.css";
function AuthenticatedContent() {
    const { instance } = useMsal();
    const [refreshKey, setRefreshKey] = useState(0);
    const [warehouses, setWarehouses] = useState([]);
    useEffect(() => {
        getWarehouses(instance)
            .then(setWarehouses)
            .catch((err) => console.error("Failed to load warehouses:", err));
    }, [instance]);
    const handleSaved = () => {
        setRefreshKey((k) => k + 1);
    };
    return (_jsxs("div", { className: "app-content", children: [_jsx(AddStockBucket, { onSaved: handleSaved, warehouses: warehouses }), _jsx(StockBucketList, { refreshKey: refreshKey, warehouses: warehouses })] }));
}
export default function App() {
    return (_jsxs(_Fragment, { children: [_jsx(Header, {}), _jsx(AuthenticatedTemplate, { children: _jsx(AuthenticatedContent, {}) }), _jsx(UnauthenticatedTemplate, { children: _jsx("p", { className: "sign-in-prompt", children: "Please sign in to manage warehouse notifications." }) })] }));
}
